module.exports = __webpack_public_path__ + "img/l1.948f616b.webp";